import React from 'react';
import aboutThumb from '../../../assets/images/inventory-purchase.jpg';

function ShowCase() {
    return (
        <>
            <section className="appie-about-area mb-50  pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="appie-about-box wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-5">
                                        <div className="about-thumb">
                                            <img
                                                className="rounded"
                                                src={aboutThumb}
                                                alt="OTO POS Receipt"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="appie-about-content">
                                            <span>Advanced inventory management software</span>
                                            <h3 className="title">
                                                Why Choose OTO Inventory Managment Software
                                            </h3>
                                            <p>
                                                Take your business to the next level, and improve
                                                profitability and customer satisfaction along the
                                                way.
                                            </p>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">
                                                        Reduces manual data entry
                                                    </h4>
                                                    <p>
                                                        OTO will help you save time and increase
                                                        accuracy by automating the data entry
                                                        process, which can have a positive impact on
                                                        your bottom
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Scalable solution</h4>
                                                    <p>
                                                        OTO is designed to grow with your business,
                                                        allowing you to add new users, locations,
                                                        and warehouses as needed.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">
                                                        Improved customer satisfaction
                                                    </h4>
                                                    <p>
                                                        By having the right items in stock at the
                                                        right time, you can improve your customer
                                                        satisfaction levels and reduce the
                                                        likelihood of lost sales due to stockouts or
                                                        long wait times.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h4 className="title">Improved forecasting</h4>
                                                    <p>
                                                        OTO uses data analytics to help you predict
                                                        demand for certain products, allowing you to
                                                        order the right amount of inventory to meet
                                                        customer needs without overstocking.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ShowCase;
